<template>
    <rkm-layout-body title="Lista de situação de jornada">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'ambulatorio-jornada-situacao-create' })"
                authorize="store-ambulatorio-jornada-situacao"
                color="primary"
            >
                Cadastrar situação de jornada
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/jornada-situacao/List'

export default {
    components: { List },
}
</script>